import { CustomAxios, getResponseData } from '../../redux/axios';
import { parseIfJson } from '../../helpers/utils';
import { WhitelistedLocationsReply } from '../../components/sync-app/sync-app.types';

type ExecuteRpcResponse = { Response?: string };

/**
 * Executes the `RPCAdapter.WhitelistedLocations` RPC for a sync app source and
 * returns the parsed reply. Throws a plain `Error` if the RPC returned no
 * response, an unparseable payload, or an error payload — react-query surfaces
 * that message to consumers via `onError`.
 */
export const fetchWhitelistedLocations = async (
  sourceId: string
): Promise<WhitelistedLocationsReply> => {
  const response = await CustomAxios.post('support/v1/syncapp/executerpc', {
    sourceId,
    rpcMethod: 'RPCAdapter.WhitelistedLocations',
    rpcParams: [],
  });
  const { Response: whitelistedResponse } = getResponseData<ExecuteRpcResponse>(response);
  if (!whitelistedResponse) {
    throw new Error('No response from sync app');
  }
  const parsed = parseIfJson(window.atob(whitelistedResponse));
  if (!parsed || typeof parsed !== 'object' || !Array.isArray(parsed.locations)) {
    throw new Error(parsed?.error ?? 'Failed to load whitelisted locations');
  }
  return parsed as WhitelistedLocationsReply;
};
